export default __webpack_public_path__ + "static/media/6.56bec296.jpg";